import { Skeleton } from '@mantine/core';

function IsLoadingCoverComparison() {
  return (
    <div className="flex flex-col items-center border border-[#D1D7DF] relative w-full">
      <span className="text-[16px] font-medium mt-[41px] w-full md:w-[80%] h-[100px]">
        <Skeleton height={8} mt={6} radius="xl" />
      </span>
      <Skeleton height={50} circle mb="xl" />

      <span className="text-[20px] relative font-medium">
        <Skeleton height={8} mt={6} radius="xl" />
      </span>

      <span>
        <Skeleton height={8} mt={6} radius="xl" />
      </span>

      <span className="text-[14px] font-medium mb-[29px]">
        {' '}
        <Skeleton height={8} mt={6} radius="xl" />
      </span>

      <div className="w-full bg-[#E7F3FC] py-[17px] min-h-[150px] mb-[23px]">
        <Skeleton height={8} mt={6} radius="xl" />
      </div>

      <div className="flex justify-between w-full px-[15px] mb-[19px]">
        <span className="font-medium text-[14px]">
          <Skeleton height={8} mt={6} radius="xl" />
        </span>
      </div>
      <div className="flex justify-between w-full px-[15px] mb-[20px]">
        <Skeleton height={8} mt={6} radius="xl" />
      </div>
      <div className="border-t-2 w-full border-[#D1D7DF] mb-[23px]"></div>

      <Skeleton height={8} mt={6} radius="xl" />
    </div>
  );
}

export default IsLoadingCoverComparison;
